import React, { useState, useEffect, useRef, memo } from 'react'

import { Duration } from 'luxon'

import Typography from './typography'

import useStyles from './clockStyle'
import { convertSlaTime } from '../../../utils/customMethods'
import { MouseOverPopover } from '../display/popover'

const Clock = (props) => {
  const classes = useStyles()

  const [timer, setTimer] = useState(0)
  const interval = useRef(null)

  const handleTimer = (assignedTime, reset, endTime) => {
    setTimer((prev) => {
      return endTime
        ? Math.abs(
            (new Date(endTime).getTime() - new Date(assignedTime).getTime()) /
              1000
          )
        : reset
        ? Math.abs((Date.now() - new Date(assignedTime).getTime()) / 1000)
        : prev + 1
    })
  }

  const renderTimer = () => {
    if(!timer) return 0

    if (props?.ticket) {
      return convertSlaTime(timer, {
        fixingSeconds: true,
        withSummary: props?.withSummary,
      })
    }
    return Duration.fromObject({
      seconds: timer,
    }).toFormat(timer < 60 ? '00:ss' : timer < 3600 ? 'mm:ss' : 'hh:mm:ss')
  }

  const renderContent = () => {
    if (props?.queueSize) {
      return props?.queueSize
    }

    return props?.withSummary && props?.ticket
      ? renderTimer()?.full
      : renderTimer()
  }

  useEffect(() => {
    if (props?.chatId && props?.assignedTime) {
      if (interval?.current) clearInterval(interval.current)

      if (!props?.endTime) {
        handleTimer(props.assignedTime, true)
        interval.current = setInterval(
          () => handleTimer(props.assignedTime),
          1000
        )
      } else {
        handleTimer(props.assignedTime, false, props.endTime)
      }
    }
    return () => clearInterval(interval?.current)
  }, [props?.chatId, props?.assignedTime, props?.status])

  return (
    <>
      <div className={classes.root}>
        {props?.withSummary && props?.ticket ? (
          <MouseOverPopover
            content={() => (
              <Typography variant="h4">{renderContent()}</Typography>
            )}
          >
            <Typography variant="h4">
              {
                convertSlaTime(timer, {
                  fixingSeconds: true,
                  withSummary: props?.withSummary,
                })?.summary
              }
            </Typography>
          </MouseOverPopover>
        ) : (
          <Typography variant="h4">{renderContent()}</Typography>
        )}
      </div>
    </>
  )
}

export default memo(Clock)
